
import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let AuthorizationRestConfigV2: IRestfulConfigMap = {
    authorizationUserRestService: {
        appPath: envConfig.appPath("base"),
        actions: {
            // 匿名用户登录
            login: {
                method: "post",
                path: "/partner/token",
                testPath: "/partner/token",
                isAuth: false
            },
            // 用户注册
            regist: {
                method: "post",
                path: "/partner/v2/registration",
                testPath: "/partner/v2/registration",
                isAuth: false
            },
            // 忘记密码
            forget: {
                method: "post",
                path: "/api/v2/users/password/forgetPassword",
                testPath: "/api/v2/users/password/forgetPassword",
                isAuth: true
            },
            //重置密码
            reset: {
                method: "put",
                path: "/api/v2/users/password/reset",
                testPath: "/api/v2/users/password/reset",
                isAuth: true
            },
            // // wx 邮箱验证 是否绑定 验证是否新用户
            // wxEmailVerify: {
            //     method: "GET",
            //     path: "/third/oauth/login/:thirdOAuthType/authorize",
            //     testPath: "/third/oauth/login/:thirdOAuthType/authorize",
            //     isAuth: false,
            //     paramDefaults: {
            //         thirdAccessToken: "@thirdAccessToken",
            //         thirdOAuthType: "@thirdOAuthType",
            //     },
            // },
            // // wx注册
            // wxEmailRegister: {
            //     method: "POST",
            //     path: "/third/oauth/register/:thirdOAuthType/authorize",
            //     testPath: "/third/oauth/register/:thirdOAuthType/authorize",
            //     isAuth: false,
            //     paramDefaults: {
            //         thirdAccessToken: "@thirdAccessToken",//请求的code
            //         email: "@email",//邮箱
            //         username: "@username",//用户名
            //         platform: "@platform",
            //         thirdOAuthType: "@thirdOAuthType",
            //     }
            // },
            // // wx获取access_token和openid
            // wxGetAccessToken: {
            //     method: "GET",
            //     path: "/third/oauth/login/:thirdOAuthType/access_token",
            //     testPath: "/third/oauth/login/:thirdOAuthType/access_token",
            //     isAuth: false,
            //     paramDefaults: {
            //         appid: "@appid",
            //         secret: "@secret",
            //         js_code: "@js_code",
            //         grant_type: "@grant_type",
            //     }
            // },
            // // wx获取access_token和openid
            // wxGetUserInfo: {
            //     method: "GET",
            //     path: "/third/oauth/login/:thirdOAuthType/access_token",
            //     testPath: "/third/oauth/login/:thirdOAuthType/access_token",
            //     isAuth: false,
            //     paramDefaults: {
            //         openid: "@openid",
            //         access_token: "@access_token",
            //         lang: "@lang",
            //     }
            // },
        }
    }
}


export { AuthorizationRestConfigV2 };